// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'Roboto Slab', 'Roboto Slab Fallback'","fontStyle":"normal"},"className":"__className_2b1760"};